import { decode } from 'he';

/**
 * 
 * @param val 
 * @returns remove tags and special characters
 */
export function removeHtml(val: string) {
    const s = val?.replace(/<\/?[^>]+(>|$)/g, "").replace(/\n/g, " ").replace(/&nbsp;/g, " ") || '';
    return decode(s);
}